// Lista misji specjalnych: klik w kafelek misji, na którą minął czas (stan
// EXPIRED, niewykonana), pokazuje modal z komunikatem zamiast braku reakcji.

document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector('.s-mission-expired');
    if (!modal) return;

    const open = () => {
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.add('is-open');
    };

    const close = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modal.hidden = true;
    };

    document.addEventListener('click', (e) => {
        if (e.target.closest('.js-expired-mission')) {
            open();
            return;
        }
        if (e.target.closest('.js-mission-expired-close')) {
            close();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) close();
    });
});
